import { render } from "./api-key.vue?vue&type=template&id=2a3b97b6&lang=pug"
import script from "./api-key.vue?vue&type=script&setup=true&lang=js"
export * from "./api-key.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__